var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-images"},[(_vm.value)?_c('div',_vm._l((_vm.value),function(image,imageIndex){return _c('img',{key:imageIndex,attrs:{"src":image}})}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }